import logoTop from "../assets/header-logo-3.png";
export default function TopImage() {
  return (
    <div className={"logoTop"}>
      <div  style={{position: 'relative', height: '100%', width: '100%'}}>
        <div style={{position: 'absolute', height: '100%', width: '100%', display: "flex", justifyContent: 'center'}}>
          <img src={logoTop} style={{height: '100%'}}/>
        </div>
      </div>
    </div>
  );
}
